export default Object.freeze({ OPEN: 'MarkdownEvent.OPEN' });
